import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import { getTemplateLanguageLabel, getTemplateTypeLabel } from '../helpers';

import CustomSystemEditField from './CustomSystemEditField';
import NameFormatter from './NameFormatter';
import ProductActionsFormatter from './ProductActionsFormatter';

const ProductColumns = ({
    filterData,
    handleClickBulkItems,
    handleClickDuplicate,
    handleClickEdit,
    rowModesModel,
    selectedRowId,
    setRowModesModel,
    setSelectedRowId,
    systemTypes,
}) => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();
    const nameColumn = [
        {
            align: 'left',
            display: 'flex',
            editable: true,
            field: 'title',
            headerName: t('Name'),
            minWidth: 300,
            renderCell: (params) => {
                const { row } = params;
                return <NameFormatter row={row} />;
            },
        },
    ];

    let columns = [
        ...nameColumn,
        {
            align: 'left',
            display: 'flex',
            field: 'type',
            headerName: t('Type'),
            minWidth: 180,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">
                        {getTemplateTypeLabel(row?.type) || '---'}
                    </Typography>
                );
            },
        },
        {
            align: 'left',
            display: 'flex',
            field: 'system_value',
            headerName: t('System type'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">
                        {row?.system?.name || '---'}
                    </Typography>
                );
            },
            minWidth: 200,
            renderEditCell: (params) => {
                return (
                    <CustomSystemEditField
                        {...params}
                        systemTypes={systemTypes}
                    />
                );
            },
        },
        {
            align: 'left',
            display: 'flex',
            field: 'language',
            headerName: t('Language'),
            minWidth: 180,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">
                        {getTemplateLanguageLabel(row?.language) || '---'}
                    </Typography>
                );
            },
        },
        {
            align: 'left',
            display: 'flex',
            field: 'created_at',
            headerName: t('Creation date'),
            minWidth: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">{row.created_at}</Typography>
                );
            },
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = nameColumn;
    }

    columns = [
        ...columns,
        {
            align: 'left',
            display: 'flex',
            field: '',
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <ProductActionsFormatter
                        filterData={filterData}
                        handleClickBulkItems={handleClickBulkItems}
                        handleClickDuplicate={handleClickDuplicate}
                        handleClickEdit={handleClickEdit}
                        row={row}
                        rowModesModel={rowModesModel}
                        selectedRowId={selectedRowId}
                        setRowModesModel={setRowModesModel}
                        setSelectedRowId={setSelectedRowId}
                    />
                );
            },
            sortable: false,
        },
    ];

    return columns;
};

ProductColumns.propTypes = {
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickDuplicate: PropTypes.func,
    handleClickEdit: PropTypes.func,
    rowModesModel: PropTypes.object,
    selectedRowId: PropTypes.func,
    setRowModesModel: PropTypes.func,
    setSelectedRowId: PropTypes.func,
    systemTypes: PropTypes.array,
};

export default ProductColumns;
